import React, { useContext, useState, useEffect } from "react";
import { collection, query, where, onSnapshot, orderBy, limit } from "firebase/firestore";
// import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { ImWarning } from "react-icons/im";
import { Link } from "react-router-dom";
import moment from "moment"

import {FirebaseContext} from '../services/Firebase/Context'
import {AuthContext} from '../services/Session/Context'

const HistoryList = () => {
  const { user } = useContext(AuthContext)
  const { db } = useContext(FirebaseContext)
  const [records, setRecords] = useState([])

  useEffect(() => {
    if(!user) return
    const q = query(collection(db, "records"), where("organisationId", "==", user.organisationId), orderBy("createdAt", 'desc'), limit(500))
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      const records = [];
      querySnapshot.forEach((doc) => {
        records.push({id: doc.id, ...doc.data()});
      });
      setRecords(records)
    });
    return () => unsubscribe()
  }, [db, user])

  return (
    <div className="container mx-auto px-4 sm:px-8">
      <div className="py-8">
        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
          <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
            <table className="min-w-full leading-normal">
              <thead>
                <tr>
                  <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                    Client
                  </th>
                  <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                      Immatriculation
                  </th>
                  <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                      Arrivée
                  </th>
                  <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                      Status
                  </th>
                  <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                  </th>
                </tr>
              </thead>
              <tbody>
                {
                  records.map(({id, customerName, customerBusiness, numberPlate, status, createdAt}) => <tr key={id} >
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      <div className="flex items-center">
                        <div className="">
                          <p className="text-gray-900 whitespace-no-wrap">
                            { customerName } { customerBusiness &&  <span className='text-yellow-600'>Pro</span> }
                          </p>
                        </div>
                      </div>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      <p className="text-gray-900 whitespace-no-wrap">
                        {numberPlate}
                      </p>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      <p className="text-gray-900 whitespace-no-wrap">
                        {createdAt && moment(createdAt.toDate()).calendar()}
                      </p>
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      { status === "new" && <span className="inline-block px-3 py-1 font-semibold text-yellow-900 leading-tight bg-yellow-100 rounded-full">
                        En attente
                      </span>}
                      { status === "pending" && <span className="inline-block px-3 py-1 font-semibold text-gray-900 leading-tight bg-gray-100 rounded-full">
                        En cours
                      </span>}
                      { status === "ended" && <span className="inline-block px-3 py-1 font-semibold text-green-900 leading-tight bg-green-100 rounded-full">
                        Clôturé
                      </span>}
                    </td>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                      <Link to={`/app/interventions/${id}`} className="text-indigo-600 hover:text-indigo-900">
                        Détails
                      </Link>
                    </td>
                  </tr>)
                }
                {
                  records.length === 0 && <tr>
                    <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm text-center" colSpan={5}>
                      <ImWarning className="h-10 w-10 p-2 mx-auto mb-2 text-yellow-300" /> Plus de données
                    </td>
                  </tr>
                }
              </tbody>
            </table>
            {/*<div className="bg-white py-5 flex flex-col xs:flex-row items-center xs:justify-between">
              <div className="flex justify-center w-full ">
                <button
                  type="button"
                  className="p-3 border flex items-center text-base rounded-lg text-gray-600 bg-white hover:bg-gray-100"
                  onClick={() => setStart(start - 50)}
                >
                  <MdChevronLeft className='font-bold' />
                </button>
                <button
                  type="button"
                  className="ml-5 p-3 border flex items-center text-base  rounded-lg text-gray-600 bg-white hover:bg-gray-100"
                  onClick={() => setStart(start + 50)}
                >
                  <MdChevronRight className='font-bold' />
                </button>
              </div>
              </div>*/}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryList